import LoaderBuilder from './components/LoaderBuilder';
import matchingRoutes from './MatchRoutes';
import { refactorRoute } from './routeConstant';

const homeRoutes = [
    {
        name: 'Default Layout',
        path: refactorRoute.HOME,
        component: LoaderBuilder(() => import('view/Home')),
        children: [
            {
                name: 'Default',
                path: refactorRoute.HOME,
                component: LoaderBuilder(
                    () => import('view/Home/Elements/RedirectDefault')
                ),
            },
            {
                name: 'Danh sách đăng ký hiến mô-tạng',
                path: refactorRoute.DONOR_REGISTER_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DangKyHien`)
                ),
            },
            {
                name: 'Danh sách đăng ký chờ ghép mô-tạng',
                path: refactorRoute.RECEIVER_REGISTER_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DangKyChoGhep`)
                ),
            },
            {
                name: 'Danh sách chờ hiến', // Danh sach dang ky hien
                path: refactorRoute.DONOR_WAITING_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachChoHien`)
                ),
            },
            {
                name: 'Danh sách chờ tuyển chọn', // Danh sach nguoi nhan
                path: refactorRoute.RECEIVER_WAITING_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachChoTuyenChon`)
                ),
            },
            {
                name: 'Danh sách đã hiến', // Danh sach da hien
                path: refactorRoute.DONOR_DONATED_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachDaHien`)
                ),
            },
            {
                name: 'Danh sách theo dõi sau ghep', // Danh sach nguoi nhan
                path: refactorRoute.RECEIVER_RECEIVED_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachTheoDoiSauGhep`)
                ),
            },

            {
                name: 'Danh sách người hiến bị loại', // Danh sach loai hien
                path: refactorRoute.DONOR_REJECTED_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachLoaiHien`)
                ),
            },

            {
                name: 'Danh sách người nhận bị loại', // Danh sach nguoi nhan
                path: refactorRoute.RECEIVER_REJECTED_LIST,
                component: LoaderBuilder(
                    () => import(`view/Home/pages/DanhSachLoaiGhep`)
                ),
            },

            {
                name: 'Danh sách công tác xã hội',
                path: refactorRoute.DONOR_CONG_TAC_XA_HOI,
                component: LoaderBuilder(
                    () => import('view/Home/pages/CongTacXaHoi')
                ),
            },
            {
                name: 'Danh sách cho - nhận',
                path: refactorRoute.MATCHING_RECEIVER,
                component: LoaderBuilder(
                    () => import('view/Home/pages/DanhSachChoNhan')
                ),
            },

            {
                name: 'Account',
                path: refactorRoute.ROUTE_ACCOUNT,
                component: LoaderBuilder(
                    () => import('view/Home/pages/Account')
                ),
            },
            {
                name: 'Change Account',
                path: refactorRoute.ROUTE_ACCOUNT_CHANGE_PROFILE,
                component: LoaderBuilder(
                    () => import('view/Home/pages/ChangeProfile')
                ),
            },
            {
                name: 'Change Password',
                path: refactorRoute.ROUTE_ACCOUNT_CHANGE_PASSWORD,
                component: LoaderBuilder(
                    () => import('view/Home/pages/ChangePassword')
                ),
            },

            ...matchingRoutes,
        ],
    },
];

export default homeRoutes;
